import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  max-width: 500px;
  height: 45px;
  background-color: #fff;
  border-radius: 25px;
  margin-top: 10px;
  border: 1px solid #e0e0e0;
  padding: 0 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const useStyles = makeStyles((theme) => ({
  iconSearch: {
    width: "18px",
    height: "18px",
    margin: "0 8px 0 12px",
    color: "#0076FF",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
  },
  buttonSearch: {
    color: "rgb(251, 167, 48)",
    cursor: "pointer",
    margin: "0 8px 0 8px",
    flexShrink: 0,
  },
  input: {
    height: "40px",
    paddingTop: "18px",
  },
  baseSearch: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    backgroundColor: "transparent",
    position: "relative",
    height: "100%",
  },
  inputSearch: {
    flex: 1,
    height: "32px",
    border: "none",
    outline: "none",
  },
  searchButton: {
    backgroundColor: " #0076FF !important",
    color: "white",
    borderRadius: "20px",
    padding: "6px 16px",
    fontSize: "12px",
    textTransform: "none !important",
    minWidth: "auto",
    height: "32px",

    "&:hover": {
      backgroundColor: "#005bb5",
    },
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    width: "250px", // mobile default
    height: "36px",
    backgroundColor: "#fff",
    borderRadius: "4px",
    border: "1px solid #e0e0e0",
    padding: "6px",
    "@media (min-width: 576px)": {
      // small screens
      width: "280px",
    },
    "@media (min-width: 768px)": {
      // medium screens
      width: "320px",
    },
    "@media (min-width: 992px)": {
      // large screens
      width: "340px",
    },
    "@media (min-width: 1600px)": {
      // extra large screens
      width: "400px",
    },
  },
}));
